window.startPlay = function (url, playerId, auto) {
    var options = {
        width: "100%",
        height: "100%",
        fluid: false,
        language: "zh-CN",
        controls: true,
        autoplay: auto,
        loop: false,
        muted: false,
        sources: [],
        controlBar: {
            children: [
                { name: "playToggle" },
                { name: "currentTimeDisplay" },
                { name: "progressControl" },
                { name: "durationDisplay" },
                { name: "timeDivider" },
                { name: "remainingTimeDisplay" },
                {
                    name: "playbackRateMenuButton",
                    playbackRates: [0.5, 1, 1.5, 2, 2.5],
                },
                { name: "volumePanel", inline: false },
                { name: "FullscreenToggle" },
            ],
        },
    };

    var isWechat = /MicroMessenger/i.test(navigator.userAgent);
    var isIOS = /iPhone|iPad/i.test(navigator.userAgent);
    var isIOSWechat = isIOS && isWechat;
    var videoEl = document.getElementById(playerId);
    var extPlayer = null;

    if (/\.m3u8(\?.*)?$/i.test(url)) {
        options.sources = [{ type: "application/x-mpegURL", src: url }];

        if (!isIOSWechat && typeof Hls !== "undefined" && Hls.isSupported()) {
            extPlayer = new Hls({
                enableWorker: true,
                lowLatencyMode: false,
                progressive: true,
                enableSoftwareAac: false,
                defaultAudioCodec: "mp3", // 强制指定音频编码
            });
            extPlayer.loadSource(url);
            extPlayer.attachMedia(videoEl);
            extPlayer.on(Hls.Events.MANIFEST_PARSED, function () {
                if (auto !== false) videoEl.play().catch(function () {});
            });
            extPlayer.on(Hls.Events.ERROR, function (e, data) {
                if (data.fatal) {
                    if (data.type === Hls.ErrorTypes.NETWORK_ERROR)
                        extPlayer.startLoad();
                    else if (data.type === Hls.ErrorTypes.MEDIA_ERROR)
                        extPlayer.recoverMediaError();
                    else extPlayer.destroy();
                }
            });
        } else {
            videoEl.src = url;
        }
    } else if (/\.flv(\?.*)?$/i.test(url)) {
        options.sources = [{ type: "video/x-flv", src: url }];

        if (typeof flvjs !== "undefined" && flvjs.isSupported()) {
            extPlayer = flvjs.createPlayer({ type: "flv", url: url });
            extPlayer.attachMediaElement(videoEl);
            extPlayer.load();
            extPlayer.on(flvjs.Events.ERROR, function (e, data) {
                console.error("FLV error:", data);
            });
        }
    } else if (/^rtmp:/i.test(url)) {
        options.techOrder = ["html5", "flash"];
        options.flash = {
            params: { wmode: "Opaque" },
            swf: "/videojs/video-js.swf",
        };
        options.sources = [{ type: "rtmp/mp4", src: url }];
    } else {
        options.sources = [{ type: "video/mp4", src: url }];
    }

    var player = videojs(playerId, options);

    if (isWechat) {
        player.one("loadedmetadata", function () {
            player.volume(1);
            player.muted(false);
            var audioTracks = player.audioTracks();
            if (audioTracks && audioTracks.length > 0) {
                for (var i = 0; i < audioTracks.length; i++)
                    audioTracks[i].enabled = true;
            }
        });
        player.on("canplay", function () {
            player.muted(false);
            player.volume(1);
        });
        player.on("loadeddata", function () {
            player.muted(false);
            player.volume(1);
        });
    }
    player.on("play", function () {
        player.muted(false);
        player.volume(1);
        // 强制启用音频轨道
        let tracks = player.audioTracks();
        for (let i = 0; i < tracks.length; i++) tracks[i].enabled = true;
    });

    player._extPlayer = extPlayer;
    return player;
};
